import {
    View as BaseView
    
} from "./index";

export const WidgetTabsView = BaseView.extend({
    className: "pz-tabs style-1 style-3", // Apply style 1 and the style 3
    history: false,
    propagateShowEvent: false,
    onRender: () => {},
    onAttach() {
        this.renderTabs();
    }
});

export { Model as WidgetTabsModel } from "./index";
